import React, { memo, useMemo, useState } from 'react';
import Button from '../../../global/atoms/button';
import GlobalModal from '../../../global/atoms/globalModal/GlobalModal';
import { getBasicAccountScreenConfigs, getCashToPodScreenConfigs } from '../../utils/guidedUtil';
import { CREATE_ACCOUNT_SCREEN } from '../../constants';
import { useAnalyticsContext } from '../../../../config/GoogleTagManagerEvents';
import { EVENT_ECOMMERCE_NAMES_CONFIG } from '../../../../constants/analyticsConstants/Ecommerce';
import './accountModal.scss';
import { isPODFlow } from '../../../cca/util/ccaUtil';

const AccountModal = () => {
    const [accountModal, setAccountModal] = useState(false);
    const basicAccountScreenConfigs = getBasicAccountScreenConfigs();
    const cashToPodScreenConfigs = getCashToPodScreenConfigs();
    const isPODFlowSelected = isPODFlow()

    const {
        standardAndCreditAccountTitle,
        bothTypeOfAccountLabel,
        bothTypeOfAccountDescription
    } = useMemo(() => {
        const source = isPODFlowSelected ? cashToPodScreenConfigs : basicAccountScreenConfigs;
        return {
            standardAndCreditAccountTitle: source?.standardAndCreditAccountTitle || "",
            bothTypeOfAccountLabel: source?.bothTypeOfAccountLabel || "",
            bothTypeOfAccountDescription: source?.bothTypeOfAccountDescription || ""
        };
    }, [isPODFlowSelected, cashToPodScreenConfigs, basicAccountScreenConfigs]);

    const { sendEventsForGRModalOpened, sendEventsForModalClosed, sendEventsForGRModalCTAClicked } =
        useAnalyticsContext();

    const handleAccountModal = () => {
        setAccountModal(!accountModal);
        if (!accountModal) {
            sendEventsForGRModalOpened(
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_VIEWED,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_MODAL_BOTH_ACCOUNT,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_INFORMATION,
                ''
            );
        } else {
            sendEventsForModalClosed(
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CTA_CLICKED,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_CLOSE,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_BUTTON,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_MODAL,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CLOSE
            );
        }
    };

    const sendAnalyticEvent = label => {
        sendEventsForGRModalCTAClicked(
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CTA_CLICKED,
            label,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_BUTTON,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_MODAL,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_EMAIL
        );
    };

    const accountTitle = () => {
        return (
            <>
                <span>{bothTypeOfAccountLabel}</span>
            </>
        );
    };

    const accountContent = () => {
        //## is used for spliting the string
        const descriptionArray = bothTypeOfAccountDescription?.split('##');
        const description1 = descriptionArray?.[0] || '';
        const description2 = descriptionArray?.[1] || '';
        const description3 = descriptionArray?.[2] || '';

        return (
            <>
                <div className="account_modal__content" tabIndex={'0'} datatestid="account-model-button">
                    {description1}
                    <a href={CREATE_ACCOUNT_SCREEN} onClick={() => sendAnalyticEvent(description2)}>
                        <strong className="account_modal__font_color">{description2}</strong>
                    </a>
                    {description3}
                </div>
            </>
        );
    };

    return (
        <>
            <Button
                type="button"
                className="account_modal__btn"
                onClick={handleAccountModal}
                aria-label="Info Icon"
                dataTestid="account-model-button">
                <strong className={`account_modal__special_heading`} tabIndex="0">
                    {standardAndCreditAccountTitle}
                </strong>
            </Button>

            <GlobalModal
                titleClasses={'account_modal_title'}
                className={'width-327'}
                isOpen={accountModal}
                onRequestClose={handleAccountModal}
                title={accountTitle()}
                content={accountContent()}
                handleClose={handleAccountModal}
            />
        </>
    );
};

export default memo(AccountModal);
